import { IServiceFormServiceValues } from 'models/shop/shopBookingTemplates';

export const hasSubservices = (currentFormValues): boolean => {
	// Check here for deleted services
	let servicesLength = 0;
	Object.keys(currentFormValues.services).map((service) => {
		if (!('deleted' in currentFormValues.services[service])) {
			servicesLength = servicesLength + 1;
		}
	});

	if (servicesLength > 1) {
		return true;
	} else {
		return false;
	}
};

export const isNormalService = (service: any, variationName: string): boolean => {
	if (service.serviceSettings.customPriceAndDuration === false && variationName === 'normalService') {
		return true;
	} else if (service.serviceSettings.customPriceAndDuration === true && variationName !== 'normalService') {
		return false;
	}
};

export const moveElement = (array, oldIndex, newIndex) => {
	const element = array.splice(oldIndex, 1)[0];

	array.splice(newIndex, 0, element);

	return array;
};

export const splitAndCombineVariations = (variations, mode?: string) => {
	const result = [];
	const combinedVariations = {};

	// Combine variations by price and duration
	for (const variation of variations) {
		let { price, duration } = variation;
		price = Number(parseFloat(price).toFixed(2));
		duration = parseInt(duration);

		if (!combinedVariations[`${price}_${duration}`]) {
			combinedVariations[`${price}_${duration}`] = [];
		}

		combinedVariations[`${price}_${duration}`].push(variation);
	}

	Object.keys(combinedVariations).forEach((key) => {
		const combinedVariation = { performers: {} };
		let bookingTemplateId = null;

		if (mode === 'edit') {
			bookingTemplateId = combinedVariations[key].find((cv) => cv.bookingTemplateId !== null).bookingTemplateId;
		}

		combinedVariations[key].map((cv) => {
			combinedVariation['performers'] = { ...combinedVariation.performers, ...cv.performers };
			combinedVariation['price'] = cv.price;
			combinedVariation['duration'] = cv.duration;
			if (mode === 'edit') {
				combinedVariation['bookingTemplateId'] = bookingTemplateId;
			}
		});

		result.push(combinedVariation);
	});

	return result;
};

export const calculateOnScreenServiceVariations = (services: IServiceFormServiceValues): number => {
	let totalVariations = 0;

	if (services && Object.keys(services).length > 0) {
		for (const service of Object.values(services)) {
			const { serviceSettings, serviceVariations, deleted } = service ?? {};

			if (!deleted) {
				if (!serviceSettings?.customPriceAndDuration) {
					// If normal service
					totalVariations++;
				} else if (serviceVariations && Object.keys(serviceVariations).length) {
					// If service with variations
					Object.entries(serviceVariations).forEach(([serKey, variation]) => {
						// Skip "normalService" key and check for selected performers (each performer has their own price field)
						if (
							serKey !== 'normalService' &&
							variation?.performers &&
							Object.values(variation.performers).some((isSelected) => isSelected)
						) {
							totalVariations += Object.values(variation.performers).filter((isSelected) => isSelected).length;
						}
					});
				}
			}
		}
	}

	if (totalVariations === 0) {
		console.info('No variations currently on screen');
	}

	return totalVariations;
};
